export default "__VITE_ASSET__ZZ4JxVQV__"